// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"_2wrtLqf0k0pH_aafRy5vJc","title":"_1CDUyOr8pzAkmmTt1X4_1Q","triangleRight":"ceexuFVFOEWMqHNl5y4A7","triangleDown":"_3rw_0ic8zOTbor55ZAnYPj","closed":"_3w4JDRXU3guMF6bIBEY7CO"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/cricket/css/accordion.css
// module id = 958
// module chunks = 0